export default __webpack_public_path__ + "static/media/Facebook.740ea2c0.png";